// Contact and Upload Types

export enum NotificationMode {
  EMAIL = 'email',
  SMS = 'sms',
}

export interface UploadContactsRequest {
  campaignId: string;
  file: File;
  notificationModes: NotificationMode[];
  notificationText?: string;
}

export interface ContactData {
  id: string;
  name: string;
  email?: string;
  phone?: string;
  created_at: string;
  updated_at: string;
}

export interface ParticipantData {
  id: string;
  batch_id?: string;
  campaign_id: string;
  name: string;
  email?: string;
  phone?: string;
  unique_token?: string;
  access_hash?: string;
  notification_modes?: string;
  notification_sent?: boolean;
  delivery_status?: string;
  message_opened?: boolean;
  survey_started?: boolean;
  survey_completed?: boolean;
  created_at: string;
  updated_at: string;
  deleted_at?: string | null;
  
  // Computed fields for display
  survey_status?: 'invited' | 'completed' | 'pending' | 'disqualified';
  review_status?: 'submitted' | 'pending' | 'not_started' | 'n/a';
  joined_at?: string;
}

export interface UploadContactsResponse {
  success: boolean;
  data?: {
    batch_id: string;
    total_processed: number;
    total_inserted: number;
    total_skipped: number;
    message: string;
    contacts?: ContactData[];
    errors?: Array<{
      row: number;
      message: string;
    }>;
  };
  message?: string;
}

export interface GetContactsResponse {
  success: boolean;
  data?: {
    contacts: ContactData[];
    total: number;
    page: number;
    per_page: number;
  };
  message?: string;
}

export interface GetParticipantsResponse {
  success: boolean;
  data?: {
    contacts: ParticipantData[];  // API returns "contacts" not "participants"
    total: number;
    limit: number;
    offset: number;
  };
  message?: string;
}

